export const AMAZONIAN = "AMAZONIAN";
export const ITSE = "ITSE";
export const STANDARD = "standard";
export const ITMPV1 = "itmpv1";
export const HAM_CONSUMER = "ham";
export const AMZNHAM_CONSUMER = "amznham";
export const PROCUREMENT = "procurement";
export const ITSE_ROLE = "itse";

export const SUPPORT_MESSAGES_LABELS = {
  PENDING: "Pending",
  UP_TO_DATE: "Up to date",
  CLOSED: "Closed",
  NONE: "N/A",
};

export const LINE_ITEMS_ERROR_UI_STRING_PATH = 'orderDetails.tabs.itemsRequested.banners.errors';
export const ACTIONS = "Actions";
